import { normalize } from "normalizr"
import queryString from "query-string"
import humps from "humps"
import { call, Effect, put, takeLeading } from "redux-saga/effects"
import API from "../../../apis/contextmeeting/api"
import { withAuthHeader } from "../../../apis/contextmeeting/withAuthHeader"
import { assetsSchema, contextFormTemplatesSchema } from "../../../apis/contextmeeting/schema"
import { AddFormToCaseActionTypes } from "./addFormToCaseTypes"
import { handleSuccess, patchNormalisedMultiple, postNormalisedMultiple } from "../../../shared/helpers/sagaHelpers"
import { displayUserMessageAction } from "../../userMessage/state/userMessageActions"
import { UserMessageTypes } from "../../userMessage/state/userMessageTypes"

export function* watchFormsActions(): Generator {
  yield takeLeading(AddFormToCaseActionTypes.FETCH_FORM_TEMPLATES_FOR_CASE_ASYNC_PENDING, fetchFormsAddableToCaseAsync)
  yield takeLeading(AddFormToCaseActionTypes.CREATE_FORM_FOR_CASE_ASYNC_PENDING, createFormForCaseAsync)
  yield takeLeading(AddFormToCaseActionTypes.MARK_FORM_COMPLETE_ASYNC_PENDING, markFormCompleteAsync)
}

export function* fetchFormsAddableToCaseAsync(action: Effect): Generator {
  try {
    const query = queryString.stringify(humps.decamelizeKeys(action.payload), { arrayFormat: "bracket" })
    const response: any = yield call(API.get, `/form_templates?${query}`, withAuthHeader())
    const normalisedResponse = normalize(response.data.formTemplates.all, [contextFormTemplatesSchema])

    const data = {
      all: normalisedResponse,
      totalItems: response.data.formTemplates.totalItems,
      totalPages: response.data.formTemplates.totalPages,
      searchTerm: response.data.formTemplates.searchTerm,
      resultsPerPage: response.data.formTemplates.resultsPerPage,
    }

    yield handleSuccess(AddFormToCaseActionTypes.FETCH_FORM_TEMPLATES_FOR_CASE_ASYNC_SUCCESS, data)
  } catch (error) {
    yield put({
      type: AddFormToCaseActionTypes.FETCH_FORM_TEMPLATES_FOR_CASE_ASYNC_ERROR,
      payload: error
    })

    yield put(displayUserMessageAction({
      messageKey: "formsNotFound",
      type: UserMessageTypes.ERROR
    }))
  }
}

export function* createFormForCaseAsync(action: Effect): Generator {
  try {
    const caseId = action.payload.caseId
    const data = { form: action.payload  }
    yield put(displayUserMessageAction({
      messageKey: "generatingForm",
      type: UserMessageTypes.MESSAGE
    }))

    const normalisedResponse = yield postNormalisedMultiple(`/cases/${caseId}/forms`, data, [assetsSchema])
    const payload = {
      all: normalisedResponse,
      caseId: caseId
    }
    yield handleSuccess(AddFormToCaseActionTypes.CREATE_FORM_FOR_CASE_ASYNC_SUCCESS, payload, "addFormToCaseSuccess")
  } catch (error) {
    yield put({
      type: AddFormToCaseActionTypes.CREATE_FORM_FOR_CASE_ASYNC_ERROR,
      payload: error
    })

    yield put(displayUserMessageAction({
      messageKey: "formsError",
      type: UserMessageTypes.ERROR
    }))
  }
}

export function* markFormCompleteAsync(action: Effect): Generator {
  try {
    const {caseId, formId} = action.payload
    const normalisedResponse = yield patchNormalisedMultiple(`/cases/${caseId}/forms/${formId}/complete`, {}, [assetsSchema])
    const payload = {
      all: normalisedResponse,
      caseId: caseId
    }
    yield handleSuccess(AddFormToCaseActionTypes.MARK_FORM_COMPLETE_ASYNC_SUCCESS, payload, 'formFinalised')
  } catch (error) {
    yield put({
      type: AddFormToCaseActionTypes.MARK_FORM_COMPLETE_ASYNC_ERROR,
      payload: error
    })

    yield put(displayUserMessageAction({
      messageKey: "formsError",
      type: UserMessageTypes.ERROR
    }))
  }
}
